import z from "zod";

const EnvSchema = z.object({
  SERVER_URL: z.url(),
  APP_VERSION: z.string(),
  MODE: z.enum(["development", "production"]),
});

export const Env = EnvSchema.parse({
  SERVER_URL: process.env.SERVER_URL,
  APP_VERSION: process.env.APP_VERSION,
  MODE: process.env.NODE_ENV,
});
